// extracted by mini-css-extract-plugin
module.exports = {"Footer":"style-module--Footer--3J_pN","LinksWrapper":"style-module--LinksWrapper--2j3KV","TAS":"style-module--TAS--1h-fU"};